import React, { useCallback } from "react";

import { FormSelect } from "../../../forms/FormSelect";
import { IFormUUID } from "../../../models/nominals";
import { IWriteReviewTemplateField } from "../../../models/reviews.interfaces";
import { useAppSelector, useDispatchers } from "../../reducers";
import { Dispatchers } from "../dispatchers";
import { getWriteReviewFormState } from "../selectors";

interface IProps {
    formUUID: IFormUUID;
    name: string;
    field: IWriteReviewTemplateField;
}

export const WriteReviewFormDropdownField = (
    props: IProps,
): React.ReactNode => {
    const dispatchers = useDispatchers(Dispatchers);

    const formState = useAppSelector((state) =>
        getWriteReviewFormState(state.reviews, props),
    );

    const value = formState?.valuesText[props.name] ?? "";
    const errors = formState.errors[props.name] ?? [];
    const showErrors = formState.showErrors;

    const onChange = useCallback(
        (e: React.FormEvent<HTMLSelectElement>) => {
            dispatchers.onReviewFormTextChange({
                formUUID: props.formUUID,
                fieldName: props.name,
                fieldValue: e.currentTarget.value,
            });
        },
        [dispatchers, props.formUUID, props.name],
    );

    const choices = props.field.options.map((option) => {
        return {
            value: option,
            label: option,
        };
    });

    return (
        <FormSelect
            name={props.name}
            required={props.field.is_required}
            label={props.field.name}
            labelPlacement={"static"}
            choices={choices}
            onChange={onChange}
            value={value}
            errors={errors}
            showErrorMessages={showErrors}
        />
    );
};
